/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Controller_TitleInputs */

const en_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Data Controller`)
};

const de_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Verantwortlicher`)
};

const fr_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Responsable du traitement`)
};

const es_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Responsable del tratamiento`)
};

const it_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Titolare del trattamento`)
};

const nl_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Verwerkingsverantwoordelijke`)
};

const pl_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Administrator danych`)
};

const fi_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Rekisterinpitäjä`)
};

const da_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Dataansvarlig`)
};

const sv_privacy_data_controller_title = /** @type {(inputs: Privacy_Data_Controller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Personuppgiftsansvarig`)
};

/**
* | output |
* | --- |
* | "1. Data Controller" |
*
* @param {Privacy_Data_Controller_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_controller_title = /** @type {((inputs?: Privacy_Data_Controller_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Controller_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_controller_title(inputs)
	if (locale === "fr") return fr_privacy_data_controller_title(inputs)
	if (locale === "es") return es_privacy_data_controller_title(inputs)
	if (locale === "it") return it_privacy_data_controller_title(inputs)
	if (locale === "nl") return nl_privacy_data_controller_title(inputs)
	if (locale === "pl") return pl_privacy_data_controller_title(inputs)
	if (locale === "fi") return fi_privacy_data_controller_title(inputs)
	if (locale === "da") return da_privacy_data_controller_title(inputs)
	if (locale === "sv") return sv_privacy_data_controller_title(inputs)
	return en_privacy_data_controller_title(inputs)
});